import { render, staticRenderFns } from "./CompletionDetail.vue?vue&type=template&id=3961245c&scoped=true&"
import script from "./CompletionDetail.vue?vue&type=script&lang=js&"
export * from "./CompletionDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompletionDetail.vue?vue&type=style&index=0&id=3961245c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3961245c",
  null
  
)

/* custom blocks */
import block0 from "./CompletionDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
